import { useEffect, useState } from "react";
import Spinner from "../common/Spinner";

const FinalCheckout = ({ cartProcessLoading }) => {
  const [loading, setLoading] = useState(cartProcessLoading);

  return (
    <div className="final-container">
      <h1>Your order is getting ready for processing</h1>
      <div className="spinner-case">
        <Spinner />
      </div>
    </div>
  );
};
export default FinalCheckout;
